import {Repository, createRepository} from '@/repositories/Base/Repository'

class ReportEditableRepository extends Repository {
    endpoint = 'vns/report_editable'

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/table`, {params})
    }

    fetchByVns(id) {
        return this.$axios.get(`${this.endpoint}/${id}/vns`)
    }

    postByVns(id, params) {
        return this.$axios.post(`${this.endpoint}/postByVns`, {...params, id: id})
    }
}

export default new ReportEditableRepository()

export const create = createRepository(ReportEditableRepository)
